import React, { useState } from "react";
import MediaPicker from "./MediaPicker";
import { toast } from "sonner";
import { X, ArrowUp, ArrowDown } from "lucide-react";
import { mediaUrl } from "../lib/media";

/**
 * MultiMediaPicker — array of URLs.
 * Reuses MediaPicker for adding new entries; shows thumbnails with reorder & remove.
 */
export default function MultiMediaPicker({ value = [], onChange, label, accept = "image" }) {
  const [pending, setPending] = useState("");

  const add = (url) => {
    if (!url) return;
    onChange([...(value || []), url]);
    setPending("");
    toast.success("Eklendi");
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const arr = [...value];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    onChange(arr);
  };

  return (
    <div className="rounded-lg border border-white/10 bg-[#0A0A11] p-3">
      {label && (
        <div className="text-[10px] tracking-widest uppercase text-white/50 font-mono-ui mb-3">
          {label} · {value.length}
        </div>
      )}
      {value.length > 0 && (
        <div className="grid grid-cols-3 gap-2 mb-3">
          {value.map((u, i) => (
            <div key={i} className="relative group aspect-video rounded-md overflow-hidden bg-black border border-white/5">
              <img src={mediaUrl(u)} alt="" className="w-full h-full object-cover" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity bg-black/60 flex items-center justify-center gap-1">
                <button type="button" onClick={() => move(i, -1)} className="w-7 h-7 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-[#A855F7]"><ArrowUp size={12} /></button>
                <button type="button" onClick={() => move(i, +1)} className="w-7 h-7 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-[#A855F7]"><ArrowDown size={12} /></button>
                <button type="button" onClick={() => remove(i)} className="w-7 h-7 rounded-full bg-red-500/90 text-white flex items-center justify-center hover:bg-red-500"><X size={12} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
      <MediaPicker value={pending} accept={accept} onChange={(u) => add(u)} label="Yeni ekle" compact />
    </div>
  );
}
